/**
 * Resolves sales-letter format (e.g. flaconcini / capsule) from URL query params.
 * Config is read from the first <script type="application/json" data-sl-format-config> on the page.
 */
if (window.SlFormatFromUrl) {
  // Already initialized (script may be included from multiple sections).
} else (function () {
  function parseConfig(script) {
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function getConfig() {
    const script = document.querySelector('script[data-sl-format-config]');
    return parseConfig(script);
  }

  function matchValue(value, config) {
    const val = (value || '').toLowerCase().trim();
    if (!val || !config) return null;

    const pairs = [
      { key: config.formatAKey, tokens: config.matchA },
      { key: config.formatBKey, tokens: config.matchB },
    ];

    for (const pair of pairs) {
      const key = (pair.key || '').toLowerCase().trim();
      if (!key) continue;
      if (val === key) return pair.key;

      const tokens = (pair.tokens || '')
        .split(',')
        .map((s) => s.toLowerCase().trim())
        .filter(Boolean);

      for (const token of tokens) {
        if (val.includes(token)) return pair.key;
      }
    }

    return null;
  }

  function resolveFormat(config) {
    if (!config || config.enabled === false) return null;

    const params = new URLSearchParams(window.location.search);
    const paramNames = (config.paramNames || 'format')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

    for (const name of paramNames) {
      const hit = matchValue(params.get(name), config);
      if (hit) return hit;
    }

    return null;
  }

  let resolvedCache;

  function resolve() {
    if (resolvedCache !== undefined) return resolvedCache;
    resolvedCache = resolveFormat(getConfig()) || null;
    return resolvedCache;
  }

  function broadcast(formatKey, source) {
    if (!formatKey) return;
    document.dispatchEvent(
      new CustomEvent('sl:format', {
        bubbles: true,
        detail: { formatKey, source: source || 'unknown' },
      })
    );
  }

  function initFromUrl() {
    const fromUrl = resolve();
    if (fromUrl) broadcast(fromUrl, 'url');
  }

  window.SlFormatFromUrl = {
    getConfig,
    resolveFormat,
    resolve,
    broadcast,
    resetCache() {
      resolvedCache = undefined;
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromUrl);
  } else {
    initFromUrl();
  }
})();
